module.exports = __webpack_public_path__ + "img/img_sub_ser_consulting04.b285625a.svg";